function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 13.245,
  cy: 12.53,
  r: 12.265,
  transform: "rotate(120 13.245 12.53)",
  fill: "#FFD747"
});

function SvgYellowBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgYellowBullet;